import { render, staticRenderFns } from "./VeJwKsXueshengModal.vue?vue&type=template&id=23ab7db8"
import script from "./VeJwKsXueshengModal.vue?vue&type=script&lang=js"
export * from "./VeJwKsXueshengModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports